module.exports = __webpack_public_path__ + "static/media/user-profile.6d7d0312.png";